import { fragSamplerColourMatrix } from '../shaders/frag-sampler-colourMatrix.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { RegionMask } from './components/regionMasks/regionMask';
import { ColourMatrixUniformData } from './pipeline-colourMatrix';
import { TexturePipelineBase } from './pipeline-texBase';
import { PipelineGlUtils } from './utils/pipeline-utils-gl';

export class ColourMatrixTexturePipeline extends TexturePipelineBase {
  public constructor(regionMaskColour = '') {
    super(vertSampler, fragSamplerColourMatrix);

    if (regionMaskColour) {
      this.regionMask = new RegionMask();
      this.fragShader = RegionMask.ModifyFragShaderText(this.fragShader, regionMaskColour);
      // console.log(`Region mask component added. Revised frag shader:`, this.fragShader);
    }
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    // ! Must acquire the first index "[0]" to keep compatibility with the node "gl" module which we use for server-side rendering (avatars).
    this.shaderProgramProps.u_colorMatrix = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uColorMatrix[0]');
    this.shaderProgramProps.u_alpha = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uAlpha');

    this.regionMask?.GetProgramProps(this.gl, this.shaderProgramProps, shaderProgram);
  }

  // Exists just for "uniformData" type extension.
  public Draw(uniformData: ColourMatrixUniformData): void {
    super.Draw(uniformData);
  }

  // Exists just for "uniformData" type extension.
  public DrawOnceForPixelData(uniformData: ColourMatrixUniformData): Uint8Array {
    return super.DrawOnceForPixelData(uniformData);
  }

  protected SetUniforms(data: ColourMatrixUniformData) {
    super.SetUniforms(data);

    this.gl.uniform1fv(this.shaderProgramProps.u_colorMatrix, data.matrix_4x5);
    this.gl.uniform1f(this.shaderProgramProps.u_alpha, data.alpha);

    // Using "this.glTextures.length" should accurately presume that the region mask texture is the only one that falls in line behind the main set of textures.
    // ! This is only particularly true for now... won't hold up for long if more components need to be made.
    this.regionMask?.SetUniforms(this.gl, this.glTextures.length, this.shaderProgramProps);
  }
}
